import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { TScanDestinationZoneDataOrError } from '../../../types';

import { TRANSFER_LIST_QUERY_KEY } from './useTransferListQuery';
import { TRANSFER_STATS_QUERY_KEY } from './useTransferStatsQuery';

/**
 * This is to track the mutation key for scanning destination zone
 */
const MUT_SCAN_DESTINATION_ZONE = 'scan-destination-zone-mutation';

interface IScanDestinationZoneMutationParam {
  onError?: (err: IApiError) => void;
  onSuccess?: (data: TScanDestinationZoneDataOrError) => void;
}

/**
 * React Query mutation function for scanning destination zone in inventory transfer.
 */
export const useScanDestinationZoneMutation = ({
  onError,
  onSuccess,
}: IScanDestinationZoneMutationParam) => {
  const queryClient = useQueryClient();
  const { isPending, isError, error, data, mutate, isSuccess, reset } =
    useMutation({
      mutationKey: [MUT_SCAN_DESTINATION_ZONE],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.scanDestinationZone,
      onError,
      onSuccess: (resData) => {
        onSuccess?.(resData);
        // Invalidate queries by their exact key prefix
        queryClient.invalidateQueries({ queryKey: [TRANSFER_LIST_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [TRANSFER_STATS_QUERY_KEY] });
      },
    });

  return {
    data,
    isScanDestinationZoneError: isError,
    isScanDestinationZoneOngoing: isPending,
    isScanDestinationZoneSuccess: isSuccess,
    scanDestinationZoneError: error,
    scanDestinationZone: mutate,
    resetScanDestinationZone: reset,
  };
};
